import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import { MoveOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/fileOptions';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useQuery } from 'data-fetching-client';
import { CRM_OBJECT_SEARCH_FIELD_NAME, CRM_OBJECT_SEARCH_BY_FLOW_ID } from 'automation-ui-management/queries/crmObjectQueries';
import getIn from 'immutable-less/transmute/getIn';
import { ReviewMetadataColumn } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import FrameworkFolderName from 'automation-ui-management/components/folders/FrameworkFolderName';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FolderMetadata = ({
  flow,
  handleOpenPanelWithRedirect
}) => {
  const {
    loading,
    data: flowCrmObjectByIdData
  } = useQuery(CRM_OBJECT_SEARCH_BY_FLOW_ID, {
    variables: {
      flowId: String(flow.flowId)
    }
  });
  const crmObject = getIn([CRM_OBJECT_SEARCH_FIELD_NAME], flowCrmObjectByIdData);
  const folderId = crmObject && getPropertyValue(crmObject, AutomationPlatformFlowProperties.FOLDER_ID);
  return /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.folder"
      })
    }), loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [folderId && folderId !== '0' ? /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "folder",
          className: "m-right-1"
        }), /*#__PURE__*/_jsx(FrameworkFolderName, {
          id: folderId
        })]
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.none"
      }), /*#__PURE__*/_jsx(UILink, {
        onClick: () => {
          handleOpenPanelWithRedirect(MoveOption.id);
        },
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.detailsStep.chooseFolder"
          })
        })
      })]
    })]
  });
};
export default FolderMetadata;